import { ProgramEnrolmentSyncSummary } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramEnrolmentSyncSummary: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<ProgramEnrolmentSyncSummary> = (fetchContext, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/admin/operations/program-enrolments/sync-summary`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramEnrolmentSyncSummary>(fetchContext.errorStore, response, 'get program enrolment sync summary'));
};
